export namespace UiIcon {

    export interface Svg {
        value: string,
        type: string,
        color?: string,
        size?: number,
        iconSize?: string,
        shape?: Shape,
        bg?: string,
        class?: string,
        rotate?: number;
        /**
         *
         * Useed only for icons on UiTag
         * @type {boolean}
         * @memberof Icon
         */
        hasAction?: boolean;
    }

    export interface Img {
        useImgTag?: boolean,
        value?: string,
        class?: string,
        width?: number,
        height?: number,
        alt?: string
    }

    export enum Shape {
        ICON = 'icon',
        CIRCLE = 'circle',
        SQUARE = 'square',
        SQUIRCLE = 'squircle'
    }


    export enum Type {
        BRAND = 'brand',
        GENERIC = 'generic',
        APP = 'app',
        DEVICES = 'devices',
        DEVICES1 = 'devices-v1',
        MENU = 'menu',
        OS = 'os',
        PRIVACY = 'privacy',
        SUBSCRIPTION = 'subscription'
    }
}